/**
** 专家登录界面--项目评估-已完成项目-详情界面
 */
<template>
    <div id="completeProDetail" class="jc-page">
        <div class="jc-panel jc-page-head">
			<span class="header-title">
                <el-page-header @back="returnPage" :content=headerTitle></el-page-header>
            </span>
            <div class="header-operation">
                <el-form ref="form" :model="form">
                    <el-form-item>
                        <el-input v-model="form.projectName" placeholder="项目名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                    <el-cascader clearable
                          :options="checkup_category_tree_list"
                          props.checkStrictly = true
                          :props="defaultProps"
                          v-model="form.type"
                          placeholder="请选择父级"
                          :show-all-levels="false"></el-cascader>
                      </el-form-item>
                    <el-form-item>
                        <el-select clearable v-model="form.status" placeholder="完成状态">
                            <el-option
                                v-for="item in statusOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                        <el-button class="button" @click="getTableListInit">查询</el-button>
                        <el-button class="button" @click="showDocDialog">项目文档</el-button>
                </el-form>
            </div>
		</div>
        <div class="jc-table-container jc-scroll-panel">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-for="item in tabPane" :key="item.checkup_subject_id" :label="item.checkup_subject_name" :name="item.checkup_subject_id">
                    <div class="main">
                        <el-table
                        :data="datatable"
                        tooltip-effect="dark"
                        style="width: 100%"
                        >
                            <!-- <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column type="index" label="序号" width="55"></el-table-column> -->
                            <el-table-column label="类别" width="200">
                                <template slot-scope="scope">{{scope.row.checkup_category_name}}</template>
                            </el-table-column>
                            <el-table-column label="项目" width="150" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row.checkup_item_name}}</template>
                            </el-table-column>
                            <el-table-column label="评估内容" width="270">
                                <template slot-scope="scope">{{scope.row.checkup_item_evaluation_content}}</template>
                            </el-table-column>
                            <el-table-column label="标准分" width="100">
                                <template slot-scope="scope">{{scope.row.checkup_item_basic_score}}</template>
                            </el-table-column>
                            <el-table-column label="扣分" width="100">
                                <template slot-scope="scope">{{scope.row.checkup_item_deduct_score}}</template>
                            </el-table-column>
                            <el-table-column label="实际得分" width="100">
                                <template slot-scope="scope">{{scope.row.checkup_item_real_score}}</template>
                            </el-table-column>
                            <el-table-column label="完成时间" width="120">
                                <template slot-scope="scope">{{scope.row.action_period_name}}</template>
                            </el-table-column>
                                <el-table-column label="考察层级" width="150">
                                <template slot-scope="scope">{{scope.row.investigation_level_name_string}}</template>
                            </el-table-column>
                                <el-table-column label="状态">
                                <template slot-scope="scope">{{scope.row.checkup_item_status_name}}</template>
                            </el-table-column>
                            <el-table-column label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button @click="handleView(scope.$index, scope.row)" type="text" size="small">详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <el-dialog title="检查条目评估" :visible.sync="checkItemDialogVisible" class="dialog" :before-close="cancelProjectEvel">
            <div class="check-item-evel-info" style="text-align:left;">
                <el-row>
                    <el-col :span="24"><h3>{{formInline.checkup_category_name}}</h3></el-col>
                </el-row>
                <el-row style="margin-top:5px;">
                    <el-col :span="8" >检查项目：{{formInline.checkup_item_no}}</el-col>
                    <el-col :span="8" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_basic_score_switch=='1'">标准分：{{formInline.checkup_item_basic_score}}</el-col>
                    <el-col :span="8">完成时间：{{formInline.action_period_name}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;">
                    <el-col :span="8">属地部门：{{formInline.checkup_department_name}}</el-col>
                    <el-col :span="8">考察层级：{{formInline.investigation_level_name_string}}</el-col>
                    <el-col :span="8">当前状态：{{formInline.checkup_item_status_info ? formInline.checkup_item_status_info.checkup_item_status_name:''}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_evaluation_content_switch=='1'">
                    <el-col :span="24">评估内容：{{formInline.checkup_item_evaluation_content}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_score_point_switch=='1'">
                    <el-col :span="24">评分标准：{{formInline.checkup_item_score_point}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_standard_require_switch=='1'">
                    <el-col :span="24">标准化要求：{{formInline.checkup_item_standard_require}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_standard_point_switch=='1'">
                    <el-col :span="24">企业达标标准：{{formInline.checkup_item_standard_point}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_review_method_switch=='1'">
                    <el-col :span="24">评审方法：{{formInline.checkup_item_review_method}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_review_criteria_no_but_switch=='1'">
                    <el-col :span="24">评审标准-否决项：{{formInline.checkup_item_review_criteria_no_but}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_review_criteria_deduction_switch=='1'">
                    <el-col :span="24">评审标准-扣分项：{{formInline.checkup_item_review_criteria_deduction}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_standard_review_number_switch=='1'">
                    <el-col :span="24">标准化评审规范号：{{formInline.checkup_item_standard_review_number}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_standard_review_content_switch=='1'">
                    <el-col :span="24">标准化评审内容：{{formInline.checkup_item_standard_review_content}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_inspection_content_switch=='1'">
                    <el-col :span="24">检查内容/考核要求: {{formInline.checkup_item_inspection_content}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_inspection_basis_switch=='1'">
                    <el-col :span="24">检查依据：{{formInline.checkup_item_inspection_basis}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_inspection_method_switch=='1'">
                    <el-col :span="24">检查方法：{{formInline.checkup_item_inspection_method}}</el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_case_image_switch=='1'">
                    <el-col :span="24">案例照片：
                            <img class="question-describe-image" v-for="image in formInline.checkup_item_case_image_list"
                                      :src="image.thumb">
                    </el-col>
                </el-row>
                <el-row style="margin-top:5px;" v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_complete_time_limit_switch=='1'">
                    <el-col :span="24">完成时限：{{formInline.checkup_item_complete_time_limit}}</el-col>
                </el-row>
            </div>
            <div class="jc-check-item-evel-section"
                v-for="inspection in formInline.checkup_item_inspection_point_content_list" 
                :key="inspection.checkup_subject_item_evaluation_origin_id">
                <h4 style="text-align:left;">{{inspection.evaluation_method_type_info.evaluation_method_type_name}}</h4>
                <div class="jc-check-item-evel-section-header">
                    <div>支持材料</div>
                    <div>{{inspection.checkup_item_inspection_point}}</div>
                </div>
                <div class="question-describe"
                    v-if="inspection.evaluation_method_type_info.evaluation_method_type_name == '书面材料' || inspection.evaluation_method_type_info.evaluation_method_type_name == '实地考察'">
                    <el-table style="margin-top:10px;" :data="inspection.expert_evaluation_list">
                    <el-table-column width="100" label="导向">
                            <template slot-scope="scope">
                                <el-select v-model="newQuestionForm.is_positive"
                                    v-if="scope.$index == modifyQuestionIndex && modifyQuestionType == inspection.evaluation_method_type_info.evaluation_method_type_name">
                                    <el-option
                                        label="正面"
                                        value="1">
                                    </el-option>
                                    <el-option
                                        label="负面"
                                        value="0">
                                    </el-option>
                                </el-select>
                                <template v-else>
                                    {{scope.row.is_positive == "1" ? "正面":"负面"}}
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="问题描述" width="200"  v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_problem_description_switch=='1'">
                            <template slot-scope="scope">
                                {{scope.row.checkup_evaluation_problem_description}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="问题分类"
                            width="200" v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_project_type_switch=='1'">
                            <template slot-scope="scope">
                                {{scope.row.checkup_evaluation_project_type_info.checkup_evaluation_project_type_name}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="照片"
                            width="100" v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_image_switch=='1'">
                            <template slot-scope="scope">
                                <el-tooltip v-for="image in scope.row.checkup_subject_item_evaluation_image_list" :key="image.source" :content="image.path">
                                    <img class="question-describe-image"
                                    :src="image.thumb"  @click="showImage(image)">
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="文档"
                            width="100" v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_file_switch=='1'">
                            <template slot-scope="scope">
                                <el-tooltip v-for="image in scope.row.checkup_subject_item_evaluation_file_list" :key="image.url" :content="image.file_name">
                                    <span class="question-describe-file" @click="showFile(image)">
                                        {{image.file_name}}
                                    </span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="修改建议" v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_improve_suggest_switch=='1'">
                            <template slot-scope="scope">
                                {{scope.row.checkup_evaluation_improve_suggest}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="整改时限" width="200"  v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_improve_time_limit_switch=='1'">
                            <template slot-scope="scope">
                                {{scope.row.checkup_item_evaluation_improve_time_limit}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="检查结果" width="200"  v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_inspection_result_switch=='1'">
                            <template slot-scope="scope">
                                {{scope.row.checkup_item_evaluation_inspection_result}}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="object-describe"
                    v-if="inspection.evaluation_method_type_info.evaluation_method_type_name == '现场询问'">
                    <el-table style="margin-top:10px;" :data="inspection.expert_evaluation_list">
                        <el-table-column width="100" label="导向">
                            <template slot-scope="scope">
                                <el-select v-model="newQuestionForm.is_positive"
                                    v-if="scope.$index == modifyQuestionIndex && modifyQuestionType == inspection.evaluation_method_type_info.evaluation_method_type_name">
                                    <el-option
                                        label="正面"
                                        value="1">
                                    </el-option>
                                    <el-option
                                        label="负面"
                                        value="0">
                                    </el-option>
                                </el-select>
                                <template v-else>
                                    {{scope.row.is_positive == "1" ? "正面":"负面"}}
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="检查对象">
                            <template slot-scope="scope">
                                {{scope.row.checkup_object_info.checkup_object_name}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="检查对象类型">
                            <template slot-scope="scope">
                                 {{scope.row.checkup_object_info.checkup_object_type_info.checkup_object_type_name}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="检查对象地址">
                            <template slot-scope="scope">
                                 {{scope.row.checkup_object_info.checkup_object_address}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="问题描述" width="200"  v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_problem_description_switch==1">
                            <template slot-scope="scope">
                                {{scope.row.checkup_evaluation_problem_description}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="问题分类"
                            width="200" v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_project_type_switch==1">
                            <template slot-scope="scope">
                                {{scope.row.checkup_evaluation_project_type_info.checkup_evaluation_project_type_name}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="照片"
                            width="100" v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_image_switch==1">
                            <template slot-scope="scope">
                                <el-tooltip v-for="image in scope.row.checkup_subject_item_evaluation_image_list" :key="image.source" :content="image.path">
                                    <img class="question-describe-image"
                                    :src="image.thumb"  @click="showImage(image)">
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="文档"
                            width="100"  v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_file_switch==1">
                            <template slot-scope="scope">
                                <el-tooltip v-for="image in scope.row.checkup_subject_item_evaluation_file_list" :key="image.url" :content="image.file_name">
                                    <span class="question-describe-file" @click="showFile(image)">
                                        {{image.file_name}}
                                    </span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="修改建议" width="200" v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_improve_suggest_switch=='1'">
                            <template slot-scope="scope">
                                {{scope.row.checkup_evaluation_improve_suggest}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="整改时限" width="200"  v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_improve_time_limit_switch=='1'">
                            <template slot-scope="scope">
                                {{scope.row.checkup_item_evaluation_improve_time_limit}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="检查结果" width="200"  v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_inspection_result_switch=='1'">
                            <template slot-scope="scope">
                                {{scope.row.checkup_item_evaluation_inspection_result}}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                
            </div>
            <div class="project-evel" style="text-align:left;">
                <h4 style="text-align:left;">项目评估</h4>
                <el-form ref="projectEvelRef" :model="projectEvelForm">
                    <el-form-item prop="" label="扣分" :prop="score" v-if="projectEvelForm.score_switch==0">
                        <el-input-number disabled style="height:40px;" v-model="projectEvelForm.score" controls-position="right" :min="0" :max="100"></el-input-number>
                    </el-form-item>
                    <el-form-item prop="" label="是否重点问题" :prop="key_issues" v-if="projectEvelForm.key_issues_switch==0">
                        <el-select v-model="projectEvelForm.key_issues" disabled controls-position="right" :min="0" :max="100">
                                    <el-option v-for="item in checkup_item_evaluation_key_issues_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelProjectEvel">返回</el-button>
            </span>
        </el-dialog>
        <!-- 项目详情Dialog -->
        <el-dialog :close-on-click-modal="false" title="项目详情" :visible.sync="dialogVisible" class="dialog">
            <el-form :inline="true" :model="formInline" class="demo-form-inline"> 
                <p>{{formInline.type}}</p>          
                <el-form-item label="评估项目:">
                    <span>{{formInline.project}}</span>
                </el-form-item>            
                <el-form-item label="标准分:">
                   <span>{{formInline.score}}</span>
                </el-form-item> 
                 <el-form-item label="完成时间:">
                   <span>{{formInline.date}}</span>
                </el-form-item>
                 <el-form-item label="属地部门:">
                   <span>{{formInline.department}}</span>
                </el-form-item>
                 <el-form-item label="考察层级:">
                   <span>{{formInline.level}}</span>
                </el-form-item>
                 <el-form-item label="当前状态:">
                   <span>{{formInline.status}}</span>
                </el-form-item>
                <el-form-item label="评估内容:" class="evalContent">
                   <span>{{formInline.evalContent}}</span>
                </el-form-item>
                <el-form-item label="评分标准:" style="width:97%">
                   <span>{{formInline.type}}</span>
                </el-form-item>     
            </el-form>
            <!-- 资料评估 -->
            <div class="dialog-info">
                <div class="infoTitle">
                    <p>资料评估</p>
                </div>
                <div class="evalMater">
                    <div class="evalMater-top">支持材料</div>
                    <div class="evalMater-wen">校园安全责任制文本/校园安全事故责任追究制度</div>
                </div>
                <div class="evalTable">
                    <el-table
                    :data="materEval"
                    tooltip-effect="dark"
                    style="width: 100%;margin-top:10px"
                    >
                        <el-table-column label="问题描述" width="200">
                            <template slot-scope="scope">
                                <span>{{scope.row.describe}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="问题分类" width="150" show-overflow-tooltip>
                            <template slot-scope="scope" >
                                <span>{{scope.row.classify}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="照片" width="150" class="picture">
                            <template slot-scope="scope">
                                <!-- {{scope.row.picture}} -->
                                 <el-image v-for="(item,i) in scope.row.picture" :key="i" :src="item" :fit="fit"></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column label="文档" width="100">
                            <template slot-scope="scope">
                                <div class="el-icon-document"></div>
                            </template>
                        </el-table-column>
                        <el-table-column label="整改建议">
                            <template slot-scope="scope">
                                <span>{{scope.row.propose}}</span>
                                <!-- <el-input v-model="scope.row.propose"></el-input> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <!-- 现场评估 -->
            <div class="dialog-scene">
                <div class="sceneTitle">
                    <p>现场评估</p>
                </div>
                <div class="sceneMater">
                    <div class="sceneMater-top">支持材料</div>
                    <div class="sceneMater-wen">校园安全责任制文本/校园安全事故责任追究制度</div>
                </div>
                <div class="sceneTable">
                    <el-table
                    :data="materScene"
                    tooltip-effect="dark"
                    style="width: 100%;margin-top:10px"
                    >
                        <el-table-column label="检查对象" width="110">
                            <template slot-scope="scope">
                                {{scope.row.checkObj}}
                                <!-- <el-input v-model="scope.row.checkObj"></el-input> -->
                            </template>
                        </el-table-column>
                        <el-table-column label="问题描述" width="160" :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                                <span>{{scope.row.problemDes}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="问题分类" width="120" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{scope.row.problemClass}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="照片" width="150" class="picture">
                            <template slot-scope="scope">
                                <!-- {{scope.row.picture}} -->
                                 <el-image v-for="(item,i) in scope.row.picture" :key="i" :src="item" :fit="fit"></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column label="文档" width="100">
                            <template slot-scope="scope">
                                <!-- {{scope.row.file}} -->
                                <div class="el-icon-document"></div>
                            </template>
                        </el-table-column>
                        <el-table-column label="整改建议">
                            <template slot-scope="scope">
                                <span>{{scope.row.propose}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <!-- 项目评估 -->
            <div class="dialog-project">
                <div class="sceneTitle">
                    <p>项目评估</p>
                </div>
                <div class="projectMater">
                    <el-form :model="projectMater" ref="projectMater" >
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="scoreFlag" prop="score">
                                    <el-input v-model="projectMater.score" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row> 
                    </el-form>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogVisible = false">返回</el-button>
            </div>
        </el-dialog>
        <el-dialog title="项目文档" :visible.sync="dialogVisibleDoc" class="docDialog">
            <el-table
                :data="projectDocumentData"
                stripe
                style="width: 100%">
                <el-table-column prop="checkup_project_file_url_info.file_name" label="文档名称"></el-table-column>
                <el-table-column prop="checkup_project_file_category_info.checkup_project_file_category_name" label="文档分类"></el-table-column>
                <el-table-column prop="create_date" label="时间"></el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <a style="color:#409EFF;font-size:12px;text-decoration:none;" target="view_window" :href="scope.row.checkup_project_file_url_info.url">查看</a>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog
          title=""
          :visible.sync="showImageDialog">
          <img :src="showImageData.source" style="width:80%;">
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="showImageDialog = false">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog
          title=""
          :visible.sync="showFileDialog">
          <div>请选择要文件：{{showFileData.file_name}}，进行的操作</div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="downloadFile">下 载</el-button>
            <el-button type="primary" @click="showFileDialog = false">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
import {eventBus} from '../../../eventbus/index'
import {
    getCheckupSubjectList,
    getCheckupSubjectItemList,
    getCheckupSubjectItemInfo,
} from '@/apis/expert'
import {
    getCheckupProjectFileList,
    getCheckupCategoryTreeList
} from '@/apis/projects'
export default {
    name:"CompleteProDetail",
    data(){
      return {
            scoreFlag: "扣分",
            headerTitle:"",
            activeName:'0',
            form:{
                projectName:"",
                type:"",
                project:"",
                status:""
            }, // 头部表单内容
            typeOptions:[
                {
                    value:'1',
                    label:'1'
                }
            ], // 项目选择
            statusOptions:[
                {
                    value:'40003',
                    label:'已评估'
                },{
                    value:'40004',
                    label:'不涉及'
                }
            ], // 完成状态
            tabPane:[],// 详情界面-检查表表内容
            dialogVisible:false, // 项目评估对话框显示标识
            dialogVisibleDoc:false, // 项目文档对话框显示标识
            formInline:{},// 对话框中头部form表单
            tableDataDoc:[
                {
                    docName:"文档A",
                    docClass:"15.1.1",
                    dateTime:"2021-10-01"
                }
            ], // "项目文档"对话框表格数据
            materEval:[
                {
                    describe:"校园文件不齐全",
                    classify:"资质证照",
                    picture:['https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg','https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'],
                    file:'',
                    propose:"补充文件"
                }
            ], // dialog对话框中“资料评估”表格数据
            materScene:[
                {
                    checkObj:"高新一小",
                    problemDes:"校园安全体制有缺失",
                    problemClass:"资质证照",
                    picture:['https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg','https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'],
                    file:'',
                    propose:"补充缺失"
                }
            ], // dialog对话框中“现场评估”表格数据
            dialogImgVisible:false,
            // evalImgList:[{name:'',url:''}], // 资料评估-照片上传
            // evalFileList:[{name:'',url:''}], // 资料评估-文件上传
            // showBtnFile:true, // 资料评估-文件上传标识
            // noneBtnFile:false, // 资料评估-文件上传标识
            // limitFile:1, //上传文件的最大数量
            // showBtnImg:true, // 资料评估-图片上传标识
            // noneBtnImg:false, // 资料评估-图片上传标识
            // limitImg:3, // 上传图片的最大数量
            projectMater:{
                score:"2"
            }, // 项目评估-扣分
            // rules:{
            //     score:[
            //         {required:true, message:'扣分不能为空'},
            //         {type:'number',message:'必须为数值'}
            //     ]
            // },
            checkup_project_id:'',
            checkup_subject_id:'0',
            tabName:"0",
            datatable:[],
            checkItemDialogVisible:false,
            formInline:{},
            projectEvelForm:{
                score_switch: '0',
                score:'',
                key_issues:'',
                key_issues_switch: '0',
            },
            dialogVisibleDoc:false,
            projectDocumentData:[],
            showImageDialog:false,
            showImageData:{thumb:''},
            showFileDialog:false,
            showFileData:{},
            checkup_item_evaluation_key_issues_list:[{id:'0',name:'否'},{id:'1',name:'是'}],
            evaluationShow: false,
            checkup_category_tree_list: [],
            defaultProps: {
                label: "checkup_category_name",
                value: "checkup_category_id",
                checkStrictly : true
            },
        }
    },
    mounted(){
         eventBus.$on('toComProjectEval', data => {
            console.log('项目详情',data);
            this.headerTitle = data.title;
            console.log(this.headerTitle);
        });
        this.checkup_project_id = this.$route.params.id
        this.loadData()
    },
    methods:{
        downloadFile(){
            window.open(this.showFileData.url)
        },
        showFile(file, files){
            this.showFileDialog = true
            this.showFileData = file
        },
        showImage(image){
            this.showImageDialog = true
            this.showImageData = image
        },
        showDocDialog(){
            this.dialogVisibleDoc = true;
            getCheckupProjectFileList({
                "checkup_project_id":this.checkup_project_id
            }).then(res=>{
                this.projectDocumentData = res.data.data.checkup_project_file_list
            })
        },
        handleClick(tab){
            getCheckupSubjectItemList({
                checkup_subject_id:this.activeName,
                "checkup_status_type":2
            }).then(res=>{
                this.datatable = res.data.data.checkup_subject_item_list
            })
        },
        //获取表格与分类
        getTableListInit() {
          getCheckupSubjectItemList({
                checkup_subject_id:this.activeName,
                checkup_item_name:this.form.projectName,
                checkup_category_id:this.form.type[this.form.type.length - 1],
                checkup_item_status_id:this.form.status,
                checkup_status_type:2

            }).then(res=>{
                this.datatable = res.data.data.checkup_subject_item_list

            })    
        },
        loadData(){
            getCheckupSubjectList({
                "checkup_project_id" : this.checkup_project_id,
                "checkup_status_type" : "2"
            }).then(res=>{
                this.tabPane = res.data.data.checkup_subject_list
                if(this.tabPane && this.tabPane.length > 0){
                    this.activeName = this.tabPane[0].checkup_subject_id
                }
                
                this.checkup_subject_id = res.data.data.checkup_subject_list[0].checkup_subject_id
                getCheckupSubjectItemList({
                    checkup_subject_id:this.checkup_subject_id,
                    "checkup_status_type":2
                }).then(res=>{
                    this.datatable = res.data.data.checkup_subject_item_list
                })
            })
            getCheckupCategoryTreeList().then((res) => {
              this.checkup_category_tree_list = res.data.data.checkup_category_tree_list;
            })
        },
        // 点击"<"返回上一级
        returnPage(){
            if (window.history.length <= 1) {
                this.$router.push({ path: "/personEval/CompleteProDetail" });
                return false;
            } else {
                this.$router.go(-1);
            }
        },
        // 点击表格中“详情”按钮--“项目详情”对话框显示
        handleView(index,row){
            this.checkItemDialogVisible = true;
            getCheckupSubjectItemInfo({
                "checkup_subject_id" : this.activeName,
                "checkup_subject_item_id" : row.checkup_subject_item_id
            }).then(res=>{
                this.formInline = res.data.data.checkup_subject_item_info
                this.projectEvelForm.score = parseInt(res.data.data.checkup_subject_item_info.checkup_item_deduct_score)
                this.projectEvelForm.score_switch = res.data.data.checkup_subject_item_info.checkup_item_evaluation_switch_info.checkup_item_evaluation_deduct_point_switch
                this.checkup_item_bcadd_bcsub = res.data.data.checkup_subject_item_info.checkup_item_evaluation_switch_info.checkup_item_bcadd_bcsub
                this.projectEvelForm.key_issues_switch = res.data.data.checkup_subject_item_info.checkup_item_evaluation_switch_info.checkup_item_evaluation_key_issues_switch
                this.projectEvelForm.key_issues = res.data.data.checkup_subject_item_info.checkup_item_evaluation_key_issues
                if (this.checkup_item_bcadd_bcsub == "2") {
                  this.scoreFlag = "加分";
                }
                if(this.projectEvelForm.score_switch == 1 || this.projectEvelForm.key_issues_switch == 1) {
                    this.evaluationShow = true;
                }
            })
        },
        cancelProjectEvel(){
            this.checkItemDialogVisible = false;
        }
    },
    beforeDestroy(){
        eventBus.$off('toComProjectEval');
    }
}
</script>
<style scoped>
#completeProDetail{
    position: relative;
}
.header {
    width: 100%;
    height: 35px !important;
    /* border-bottom: 1px solid #ccc; */
}
.header-left {
    width: 200px;
    text-align: left;
    position: absolute;
}
.header-title {
    font-weight: bold;
    /* display: inline-block;
    width: 100px; */
}
.header-right {
    position: absolute;
    right: 20px;
    /* width: 55%; */
    height: 35px;
    top: -15px;
}
.el-form{
    display: flex;
    height: 35px;
}
.el-form-item {
    width: 180px;
    margin-right: 10px;
}
.button {
    height: 38px;
    color: #fff;
    background-color: #000;
}
#completeProDetail >>> .el-input__inner {
    height: 35px;
    padding: 0 10px;
    border: 1px solid #000;
}
#completeProDetail >>> .el-input input::-webkit-input-placeholder{
    color: #9e9fa3;
}
/* 表格样式修改 */
#completeProDetail >>> .el-main {
    padding: 10px 20px;
} 
.el-table{
    color: #000;
}
#completeProDetail >>> .el-table thead{
    color:#000;
    font-weight: unset;
}
#completeProDetail >>> .el-table__header{
    width: 100%;
   
}
#completeProDetail >>> .el-table th.el-table__cell{
    background-color: #f3f3f3;
}
/* #organlist >>> .el-table tr{
    
} */
#completeProDetail >>> .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: unset;
}
.el-button--text{
    color: #000;
    font-size: 13px;
}
.el-table__row>td{
    border: none;
}
.el-table::before{
    height: 0px;
}
#completeProDetail >>> .el-checkbox__inner{
    width: 16px;
    height: 16px;
    border: 1px solid #9e9fa3;
}
/* 对话框样式修改 */
#completeProDetail >>> .el-dialog {
    margin-top: 3vh !important;
    width: 55%;
}
#completeProDetail >>> .docDialog .el-dialog{
    width: 50%;
    margin-top: 20vh !important;
}
#completeProDetail >>> .dialog .el-dialog__header,
#completeProDetail >>> .docDialog .el-dialog__header{
    text-align: left;
     padding: 10px 10px 0px;
}
#completeProDetail >>> .dialog .el-dialog__title,
#completeProDetail >>> .docDialog .el-dialog__title{
    font-size: 16px; 
}
#completeProDetail >>> .dialog .el-dialog__body{
    /* padding: 10px 10px; */
    padding: 0px 10px 10px;
    color: #000;
}
#completeProDetail >>> .dialog .el-dialog__body .el-form{
    width: 100%;
    height: 100%;
    display: block;
}
#completeProDetail >>> .dialog .el-dialog__body .el-form p {
    padding: 0px;
    text-align: left;
    font-size: 16px;
}
#completeProDetail >>> .dialog .el-dialog__body .el-form-item {
    width: 31%;
    margin-bottom: unset;
    text-align: left;
}
#completeProDetail >>> .dialog .el-dialog__body .el-form-item.evalContent {
    width: 97%;
}
#completeProDetail >>> .dialog .el-dialog__body .evalContent .el-form-item__content{
    width: 91%;
}
#completeProDetail >>> .dialog .el-form-item__label{
    color: #000;
    font-size: 14px;
    text-align: left;
    line-height: 30px;
}
#completeProDetail >>> .dialog .el-form-item__content {
    line-height: 30px;
    font-size: 14px;
}
/* #goingProDetail >>> .dialog .el-input__inner {
    border: 1px solid #409eff;
    color: #000;
} */
#completeProDetail >>> .dialog .el-select {
    width: 100%;
}
#completeProDetail >>> .dialog .el-dialog__footer {
    padding: 0px 10px 10px;
}
.el-icon-arrow-left {
    font-weight: bold;
}
/* 资料评论、现场评估样式 */
.dialog-info .infoTitle p,
.dialog-scene .sceneTitle p,
.dialog-project .sceneTitle p {
    text-align: left;
    font-weight: bold;
    margin-bottom: 5px;
}
.dialog-info .evalMater,
.dialog-scene .sceneMater{
    width: 100%;
    height: 40px;
    border: 1px solid #dfdfdf;
}
.dialog-info .evalMater .evalMater-top,
.dialog-info .evalMater .evalMater-wen,
.dialog-scene .sceneMater .sceneMater-top,
.dialog-scene .sceneMater .sceneMater-wen {
    width: 100%;
    height: 20px;
    text-align: left;
    font-size: 13px;
    line-height: 20px;
    padding-left: 15px;
    box-sizing: border-box;
}
.dialog-info .evalMater .evalMater-top,
.dialog-scene .sceneMater .sceneMater-top {
    background-color: #dfdfdf;
}
/* 修改表格th表头高度 */
#completeProDetail >>> .dialog .el-table__header tr,
#completeProDetail >>> .dialog .el-table__header th {
    padding: 0;
    height: 35px;
    line-height: 35px;
}
/* 修改表格td单元格高度 */
#completeProDetail >>> .dialog .el-table__body tr,
#completeProDetail >>> .dialog .el-table__body td {
    padding: 5px 0px;
    height: 35px;
    line-height: 35px;
}
#completeProDetail >>> .dialog .el-input__inner {
    height: 30px;
    border: 2px solid #ccc;
}
#completeProDetail >>> .dialog .el-table td.el-table__cell,.dialog .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #ccc;
}


#completeProDetail >>> .dialog .avatar {
    width: 40px;
    height: 30px;
    display: inline-block;
  }
/* 照片上传样式修改 */
#completeProDetail >>> .dialog .el-image{
    width: 30px;
    height: 30px;
    margin-right: 5px;
}
/* 文件上传样式 */
/* #completeProDetail >>> .dialog .el-upload-list__item:first-child {
    margin-top: unset;
}
#completeProDetail >>> .dialog .el-upload-list__item {
    margin-top: unset;
}
#completeProDetail >>> .el-upload-list__item-name {
    margin-right: 20px;
} */


#completeProDetail >>> .dialog .el-divider--horizontal{
    margin: 0px;
}

#completeProDetail >>> .dialog .dialog-project .el-input__inner {
    border: 1px solid #409eff !important;
    color: #000;
}
#completeProDetail >>> .dialog .dialog-project .el-input-number {
    width: 260px;
}
</style>


// WEBPACK FOOTER //
// src/views/Expert/CompleteProject/CompleteProDetail.vue